import { render, staticRenderFns } from "./PenerimaanDetail.vue?vue&type=template&id=21e22124"
import script from "./PenerimaanDetail.vue?vue&type=script&lang=js"
export * from "./PenerimaanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports